import React from 'react'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import IntlUtil from '../../../utils/IntlUtil'
import classNames from 'classnames'

const styles = ({ palette, spacing: { unit } }) => ({
  root: {
    padding: `${unit * 1.17}px ${unit * 2}px`,
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
  },
  label: {
    marginLeft: unit * 0.5,
    marginRight: unit * 0.5,
  },
})

const PointsBox = props => {
  const {
    classes,
    className,
    points = 0,
    type = IntlUtil.label('J_POINTS'),
    color,
    pointsDetail,
    pointsData,
    member,
    getColorByType,
    getPointsLabel,
  } = props

  // Check if we're using multi point approach
  if (pointsDetail && pointsDetail.length > 0) {
    return (
      <div className={classes.container}>
        {pointsDetail.map((item, index) => {
          const { points, type, triggerId } = item
          const itemColor = getColorByType(member.jpoints, type)
          const textStyle = { color: itemColor }

          return (
            <div
              key={triggerId || index}
              className={
                classNames(classes.root, className) + ` !bg-[${itemColor.replace('#', '')}]`
              }
            >
              <Typography variant="h5" style={textStyle}>
                {points + ' '} {IntlUtil.label(getPointsLabel(type))}
              </Typography>
            </div>
          )
        })}
      </div>
    )
  }

  // Original single points rendering for backward compatibility
  const textStyle = color ? { color } : {}
  const bgColorClass = color ? ` !bg-[${color.replace('#', '')}]` : ''

  return (
    <div className={classNames(classes.root, className) + bgColorClass}>
      <Typography variant="h5" style={textStyle}>
        {IntlUtil.num(points)}
      </Typography>
      <Typography className={classes.label} style={textStyle}>
        {type}
      </Typography>
    </div>
  )
}

export default withStyles(styles)(PointsBox)
